import * as types from '../types/taskTypes';
import * as taskServices from '../../services/taskServices';

export function fetchTasks(params) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_TASKS_REQUEST });
    try {
      const data = await taskServices.fetchTasks(params);
      const list = Array.isArray(data) ? data : (data.tasks || data || []);
      dispatch({ type: types.FETCH_TASKS_SUCCESS, payload: list });
    } catch (error) {
      dispatch({ type: types.FETCH_TASKS_FAILURE, payload: error.message });
    }
  };
}

export function fetchTaskStats() {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_TASK_STATS_REQUEST });
    try {
      const data = await taskServices.fetchTaskStats();
      dispatch({ type: types.FETCH_TASK_STATS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: types.FETCH_TASK_STATS_FAILURE, payload: error.message });
    }
  };
}

export function fetchTaskById(id) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_TASK_BY_ID_REQUEST });
    try {
      const data = await taskServices.getTaskById(id);
      dispatch({ type: types.FETCH_TASK_BY_ID_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: types.FETCH_TASK_BY_ID_FAILURE, payload: error.message });
    }
  };
}

export function createTask(payload) {
  return async (dispatch) => {
    dispatch({ type: types.CREATE_TASK_REQUEST });
    try {
      const data = await taskServices.createTask(payload);
      dispatch({ type: types.CREATE_TASK_SUCCESS, payload: data });
      return { success: true, data };
    } catch (error) {
      dispatch({ type: types.CREATE_TASK_FAILURE, payload: error.message });
      return { success: false, error: error.message };
    }
  };
}

export function updateTask(id, payload) {
  return async (dispatch) => {
    dispatch({ type: types.UPDATE_TASK_REQUEST });
    try {
      const data = await taskServices.updateTask(id, payload);
      dispatch({ type: types.UPDATE_TASK_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: types.UPDATE_TASK_FAILURE, payload: error.message });
    }
  };
}

export function deleteTask(id) {
  return async (dispatch) => {
    dispatch({ type: types.DELETE_TASK_REQUEST });
    try {
      await taskServices.deleteTask(id);
      dispatch({ type: types.DELETE_TASK_SUCCESS, payload: id });
    } catch (error) {
      dispatch({ type: types.DELETE_TASK_FAILURE, payload: error.message });
    }
  };
}

